// @ts-nocheck
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import cx from 'classnames';

import { useLazySearchCustomersQuery } from '@greenkub-fronts/data-access';
import { GROUP_NAME, Project, User } from '@greenkub-fronts/shared/interface';
import {
  DisplayDate,
  formatCurrency,
  getStatusBySlug,
  useCustomDebounce,
} from '@greenkub-fronts/shared/utils';

import styles from './customer-search.module.scss';
import GKInput from '../../forms/GKInput/gk-input';
import { IconEnum } from '../../icon/icon.enum';
import { Icon } from '../../icon/icon';

export const CustomerSearch = () => {
  const [customers, setCustomers] = useState<User[]>([]);
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const wrapperRef = useRef();

  const navigate = useNavigate();

  const [searchCustomer] = useLazySearchCustomersQuery();

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const onFocus = () => {
    if (customers.length > 0) {
      setIsSearching(true);
    }
  };

  useCustomDebounce(
    () => {
      if (
        !searchValue ||
        searchValue.trim() === '' ||
        searchValue.trim().length < 3
      ) {
        setIsSearching(false);
        return;
      }
      if (!isSearching) {
        setIsSearching(true);
      }

      const result = searchCustomer({
        search: searchValue.toLowerCase(),
        groupName: GROUP_NAME.CUSTOMER_PROJECT_SEARCH,
      });

      result.then((resp: any) => {
        setCustomers(resp.data);
      });
    },
    500,
    [searchValue]
  );

  const handleClickOutside = (e) => {
    if (
      wrapperRef &&
      wrapperRef.current !== undefined &&
      !wrapperRef.current.contains(e.target)
    ) {
      setIsSearching(false);
    }
  };

  return (
    <div className={styles['CustomerSearch']} ref={wrapperRef}>
      <div className={cx(styles['form-input'])}>
        <Icon name={IconEnum.SEARCH} />
        <GKInput
          name="search-customer"
          type="text"
          placeholder="Rechercher un client, 3 lettres minimums"
          onChangeValue={(e) => setSearchValue(e.currentTarget.value)}
          defaultValue={searchValue}
          onFocus={onFocus}
          className={styles['form-input']}
          // onBlur={() => setIsFocused(false)}
        />
      </div>

      {isSearching && (
        <ul className={styles['CustomerSearch-results']}>
          <TransitionGroup>
            {customers &&
              customers.length &&
              customers.map((customer: User) => (
                <CSSTransition
                  classNames={'appear-search'}
                  key={customer.id}
                  in={true}
                  enter={true}
                  timeout={700}
                >
                  <div key={customer.id} className="row align-center">
                    <li
                      key={customer.id}
                      className={styles['CustomerSearch-item']}
                    >
                      <div className={styles['CustomerSearch-item-body']}>
                        <div
                          onClick={() => {
                            setIsSearching(false);
                            navigate(`/customer/${customer.id}`);
                          }}
                          onAuxClick={() =>
                            window.open(`/customer/${customer.id}`, '_blank')
                          }
                          className={styles['CustomerSearch-first-two-column']}
                        >
                          <div className={styles['CustomerSearch-item-name']}>
                            <p>{customer.firstName}</p>
                            <p>{customer.lastName}</p>
                          </div>
                          <div
                            className={styles['CustomerSearch-item-contact']}
                          >
                            <p>
                              <Icon name={IconEnum.PHONE} />
                              {customer.phone || '-------'}
                            </p>
                            <p>
                              <Icon name={IconEnum.MOBILE} />
                              {customer.mobile || '-------'}
                            </p>
                            <p>
                              <Icon name={IconEnum.MAIL} />{' '}
                              {customer.email || '-------'}
                            </p>
                          </div>
                        </div>

                        <div className={styles['CustomerSearch-item-projects']}>
                          <p>PROJETS</p>
                          <div
                            className={
                              styles['CustomerSearch-item-list-projects']
                            }
                          >
                            {customer.projects.length > 0 &&
                              customer.projects
                                .filter(
                                  (project: Project) => !project.deletedAt
                                )
                                .map((project: Project) => (
                                  <div
                                    key={project.id}
                                    className={
                                      styles[
                                        'CustomerSearch-item-list-projects-item'
                                      ]
                                    }
                                  >
                                    <p
                                      onClick={() => {
                                        setIsSearching(false);
                                        navigate(`/task/${project.id}`);
                                      }}
                                      onAuxClick={() =>
                                        window.open(
                                          `/task/${project.id}`,
                                          '_blank'
                                        )
                                      }
                                      className={cx(
                                        `status-${project.status}`,
                                        styles['btn-link']
                                      )}
                                    >
                                      {project.bdcSignedAt && (
                                        <>
                                          <span
                                            style={{ whiteSpace: 'nowrap' }}
                                          >
                                            Signé le{' '}
                                            {DisplayDate(project.bdcSignedAt)}
                                          </span>
                                          <br />
                                        </>
                                      )}
                                      {project.isCCMI && (
                                        <>
                                          <span>
                                            <strong>CCMI</strong>
                                          </span>
                                          <br />
                                        </>
                                      )}
                                      <span>
                                        <strong>
                                          {getStatusBySlug(project.status)}
                                        </strong>
                                      </span>
                                      <br />
                                      {project.totalPriceWithVat > 0 && (
                                        <span>
                                          {formatCurrency(
                                            project.totalPriceWithVat -
                                              project.adjustment
                                          )}
                                        </span>
                                      )}
                                      <Icon
                                        className={styles['Link-Arrow']}
                                        name={IconEnum.SEND}
                                      />
                                    </p>
                                    {/* {project.configurations[0]?.chosenStudioList
                                      ?.studio?.name && (
                                      <p>
                                        {
                                          project.configurations[0]
                                            .chosenStudioList.studio.name
                                        }
                                      </p>
                                    )} */}
                                  </div>
                                ))}
                          </div>
                        </div>
                      </div>
                    </li>
                  </div>
                </CSSTransition>
              ))}
          </TransitionGroup>
        </ul>
      )}
    </div>
  );
};
